import { kea } from "kea";

import api from '../utils/api';

export const organisationlogic = kea({
	actions: {
		fetch: true,
		update: (organisation) => ({ organisation }),

		set: (organisation) => ({ organisation }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		organisation: [null, {
			set: (_, { organisation }) => organisation,
		}],
		loading: [false, {
			fetch: () => true,
			update: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async (_, breakpoint) => {
			let url = '/organisation';
			let res;
			try {
				res = await api({ url });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.set(json.payload);
			else actions.setError(json.error);
		},
		update: async ({ organisation }, breakpoint) => {
			await breakpoint(300);
			let url = `/organisation`;
			let res;
			try {
				res = await api({ url, method: 'put', body: organisation });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				actions.setSuccess('Organisation Updated.');
			} else actions.setError(json.error);
		}
	})
});

export default organisationlogic;